import apiClient from "../clients/apiClient";
import { safeRequest } from "../safeRequest";

export const JoinService = {
  async join(inviteToken) {
    if (!inviteToken) {
      return { status: 400, data: null, message: "inviteToken ausente" };
    }

    // Swagger: /join/{inviteToken}. Assumimos POST vazio com Bearer via interceptor.
    return safeRequest(
      apiClient.post(`/join/${inviteToken}`).then((response) => response.data),
    );
  },
};

